function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, CSSProperties, ReactElement, Ref, ElementType } from 'react';
import cn from 'classnames';
require("./Badge.css");
var styles = {
  "Root": "Badge-module-Root_1dY",
  "filledVariant": "Badge-module-filledVariant_1Oz",
  "outlinedVariant": "Badge-module-outlinedVariant_zRH",
  "sRoundness": "Badge-module-sRoundness_2DA",
  "mRoundness": "Badge-module-mRoundness_3j8",
  "lRoundness": "Badge-module-lRoundness_2sp",
  "sSize": "Badge-module-sSize_lGc",
  "mSize": "Badge-module-mSize_2GX",
  "lSize": "Badge-module-lSize_2U4",
  "isEmpty": "Badge-module-isEmpty_2A-"
};
export const BadgeVariants = {
  filled: 'filled',
  outlined: 'outlined'
};
export const BadgeRoundnesses = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const BadgeSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const Badge = ({
  bg = '#FF0066',
  children,
  className,
  content,
  controlRef,
  innerRef,
  roundness = 's',
  showZero = false,
  size = 'm',
  style = {},
  tag = 'div',
  variant = 'filled',
  ...props
}) => {
  const Component = tag;
  if (!showZero && !content) return null;
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: innerRef || controlRef,
    className: cn(styles.Root, styles[`${variant}Variant`], styles[`${roundness}Roundness`], styles[`${size}Size`], {
      [styles.isEmpty]: !content
    }, className),
    style: {
      '--badge-color': bg,
      ...style
    }
  }, props), content);
};
if (process.env.NODE_ENV !== 'production') {
  Badge.displayName = 'Badge';
}